import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from "react-router-dom";
import './styles/tokens.css';
import {ResultContextProvider} from './context/ResultContextProvider'
import {NotificationContextProvider} from './context/NotificationContextProvider'
import axios from 'axios';
import 'i18next';
import i18next from 'i18next';
import { activeElectionId } from './config/states';

axios.defaults.baseURL='https://election.rollingoaks.io/';

// Pin every public-api request to this deployment's election so the site keeps
// showing its own election forever, even after newer elections are activated.
// The article endpoints take the same pin as `eid` (see article_with_gallery.php
// / article_tag.php, which read $_GET['eid']).
axios.interceptors.request.use((config) => {
  const eid = activeElectionId();
  const url = config.url || '';
  if (eid) {
    if (url.startsWith('public-api/')) {
      config.url += (url.includes('?') ? '&' : '?') + `election_id=${eid}`;
    } else if (url.startsWith('article_with_gallery.php') || url.startsWith('article_tag.php')) {
      config.url += (url.includes('?') ? '&' : '?') + `eid=${eid}`;
    }
  }
  return config;
});

const lang=localStorage.getItem('lang') || 'zh_CN';
//axios.defaults.headers.common['Accept-Language']=lang
i18next.changeLanguage(lang);

ReactDOM.render(
<HelmetProvider>
  <ResultContextProvider>
    <NotificationContextProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App/>
      </BrowserRouter>
    </NotificationContextProvider>
  </ResultContextProvider>
</HelmetProvider>
,document.getElementById('root'))